<template>
  <!--begin::Navbar-->

  <div class="row">
    <div v-if="!item.company">
      <Loading/>
    </div>
    <div class="col-12 text-center">
      <div id="invoice" class="invoice min-vh-70">
        <div v-if="item.company" class="invoice-code">
          <div :class="logoClassName" class="text-center">
            <img :src="item.company.url" style="display: block"/>
          </div>
        </div>
        <div v-if="item.company" class="invoice-content">
          <div :class="className">
            <p class="invoice-title">{{ $t('app.customer_name') }}: </p>
            <p>{{ item.user.name }}</p>
          </div>
          <div :class="className">
            <p class="invoice-title">{{ $t('app.customer_phone') }}: </p>
            <p>{{ item.user.phone }}</p>
          </div>
          <div :class="className">
            <p class="invoice-title">{{ $t('app.amount') }}: </p>
            <p>{{ item.amount + " " + $t('app.' + item.currency) }}</p>
          </div>
          <div :class="className">
            <p class="invoice-title">{{ $t('app.subject') }}: </p>
            <p>{{ item.subject }}</p>
          </div>
          <div :class="className">
            <p class="invoice-title">{{ $t('app.beneficiary_name') }}: </p>
            <p>{{ item.company.name }}</p>
          </div>
          <div class=" pt-4 pay_now">
            <button v-if="item.expired == 0" class="btn btn-primary w-50" @click="goToLink">{{ $t('app.pay_now') }}</button>
            <p class="badge text-danger" v-if="item.expired == 2">{{ $t('app.payment_link_is_expired') }}</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import Loading from "@/components/Loading.vue";

export default {
  name: 'index',
  components: {Loading},
  data: function () {
    return {
      direction: localStorage.getItem('locale') == "ar" ? "rtl" : "ltr",
      className: localStorage.getItem('locale') == "ar" ? "text-end" : "text-start",
      logoClassName: localStorage.getItem('locale') == "ar" ? "text-start" : "text-end",
      url: '',
      pgLoading: true,
      item: {
        expired:"",
        company: null
      },
    }
  },
  created() {
    this.goToLink();
  },
  methods: {
    goToLink() {
      this.url = window.domainURL + '/warnings/pdf/' + this.$route.params.code;
      window.location.replace(this.url);
    }
  }
}

</script>

<style>
.pay_now , .pay_now .btn {
  text-align: center !important;
}
.invoice {
  width: 340px;
  padding: 10px;
  background-color: hsl(0, 0%, 100%);
  border-radius: 20px;
  box-shadow: 0 0 8px rgba(30, 30, 30, 0.1);
  cursor: pointer;
  transition: transform 0.3s;
  margin: 5% auto;
}

.invoice-code {
  background-color: #f5f8fa;
  display: flex;
  justify-content: center;
  padding: 20px;
  border-radius: 10px;
  transition: transform 0.3s;
}

.invoice-code img {
  width: 85px;
  height: 85px;
  display: inline-block !important;
}

.invoice-content {
  padding: 20px;
  text-align: center;
  transition: padding 0.3s;
}

p {
  display: inline-block;
  font-weight: 400;
  font-size: 14px;
}

.invoice-title {
  color: hsl(218, 44%, 22%);
  margin-bottom: 20px;
  display: inline-block;
  width: 45%;
}

</style>